import { ButtonIcon } from '@vds/button-icons';
import { Icon } from '@vds/icons';
import { Micro, Title } from '@vds/typography'
import React, { useState, useEffect } from 'react';
import './CourseDetailsModalContent.scss';
import { Notification } from '@vds/notifications';
import { getImageToBeRendered } from '../../../utility/utils';

const CourseDetailsModalContent = ({ title, shareAEMData, currentEvent }) => {
  const [isLinkClicked, setIsLinkClicked] = useState(false);
  const aemUrlurlpath = global.config.AEM_API_BASE_PATH ;
  const getEventCity = currentEvent?.modules[0].inPersonLocation?.city
  const handleIconClick = (option) => {
    const currenturl = window.location.href;
    if (option?.key === 'link') {
      setIsLinkClicked(true);
      navigator.clipboard.writeText(currenturl);
    }
    else if (option?.key == "linkedin") {
      var url = option?.url + currenturl + "&title=" + encodeURI(title) + "&summary=" + encodeURI(option?.summary?.length > 0 ? option?.summary : title) + "&source=" + currenturl;
      window.open(encodeURI(url), "_blank");
    }
    else if (option?.key === "facebook") {
      var url = option?.url + currenturl;
      window.open(encodeURI(url), "_blank");
    }
    else {
      const getText = option?.text 
      const replCity = getText.replace("[$city]",getEventCity)
      var url = option?.url + currenturl + "&via=" + option?.via + "&text=" + replCity + title;
      window.open(encodeURI(url), "_blank");
    }
  };

  useEffect(() => {
    // Save current scroll position
    const scrollY = window.scrollY;

    // Prevent background scroll
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    return () => {
      // Restore scroll when modal closes
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';

      // Restore scroll position
      window.scrollTo(0, scrollY);
    };
  }, []);
  const [socialIcon, setSocialIcon] = React.useState(null);
  React.useEffect(() => {
    let cancelled = false;
    const loadIcon = async () => {
      const url = await getImageToBeRendered("","","skillimg","","",shareAEMData?.linkedInImg,"",'insScmIcon');
      if (!cancelled) setSocialIcon(url);
    };
    loadIcon();
    return () => { cancelled = true; };
  }, [shareAEMData?.linkedInImg]);
  
  return (
    <div>
      <div className='mb-8X'><Title size='medium' bold>{shareAEMData?.shareModelTitle}</Title></div>
      <div className='share-options-container'>
        {shareAEMData?.shareIconsList?.map((option, index) => (
          <div key={index} className='align-center n-flexDirectionCol share-options'>
            {option?.key === "linkedin" ? <button className='share-icon-button' onClick={() => handleIconClick(option)}>
              {/* <img src={aemUrlurlpath + shareAEMData?.linkedInImg} alt={option.text} aria-label= {`Share content on ${option.sharelabel} button`}/> */}
              <img src={socialIcon} alt={option.text} aria-label= {`Share content on ${option.sharelabel} button`}/>
            </button> :
              <ButtonIcon
                kind="lowContrast"
                size="large"
                renderIcon={(props) => <Icon name={option.shareIconClass} {...props} />}
                onClick={() => handleIconClick(option)}
                ariaLabel={option?.key==="link"? option?.sharelabel : `Share content on ${option.sharelabel} button`}
              />}
            <div className='mt-2X text-center'><Micro>{option.sharelabel}</Micro></div>
          </div>
        ))}
      </div>
      {isLinkClicked && <div className='mt-8X'>
        <Notification
          type="success"
          title={shareAEMData?.copyClipboardTxt}
          surface="light"
          hideCloseButton={true}
        />
      </div>}
    </div>
  )
}

export default CourseDetailsModalContent